import { lazy, type ComponentType, type LazyExoticComponent } from "react";

const CHUNK_RECOVERY_KEY = "yunmao-erp:chunk-recovery";
const chunkErrorPatterns = [
  /error loading dynamically imported module/i,
  /failed to fetch dynamically imported module/i,
  /importing a module script failed/i,
  /loading chunk .* failed/i,
  /chunkloaderror/i,
];

export const isChunkLoadError = (error: unknown) => {
  const message = error instanceof Error ? error.message : String(error);
  return chunkErrorPatterns.some((pattern) => pattern.test(message));
};

export const clearChunkRecovery = () => {
  if (typeof window !== "undefined") {
    window.sessionStorage.removeItem(CHUNK_RECOVERY_KEY);
  }
};

export const forceApplicationReload = () => {
  clearChunkRecovery();
  window.location.reload();
};

export function lazyWithRetry<T extends ComponentType<object>>(
  loader: () => Promise<{ default: T }>,
): LazyExoticComponent<T> {
  return lazy(async () => {
    try {
      const module = await loader();
      clearChunkRecovery();
      return module;
    } catch (error) {
      if (typeof window !== "undefined" && isChunkLoadError(error)) {
        const marker = `${window.location.pathname}${window.location.search}`;
        if (window.sessionStorage.getItem(CHUNK_RECOVERY_KEY) !== marker) {
          window.sessionStorage.setItem(CHUNK_RECOVERY_KEY, marker);
          window.location.reload();
          return new Promise<never>(() => undefined);
        }
      }
      throw error;
    }
  });
}
